import { StyleSheet } from "react-native";
import { colors, fontSizes } from "@/app/constants/styles";

export const confirmedOrderStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.maroon,
    borderRadius: 8,
    paddingVertical: 30,
    paddingHorizontal: 15,
  },
  buttonContainer: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  confirmOrderHeader: {
    fontSize: fontSizes.x20,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
    marginBottom: 10,
  },
  confirmOrderText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.white,
    textAlign: "center",
    marginBottom: 30,
  },
  newOrderContainer: {
    flex: 1,
    paddingHorizontal: "20%",
  },
  newOrderButton: {
    alignItems: "center",
    backgroundColor: colors.albaikRed,
    height: 50,
    borderRadius: 8,
    justifyContent: "center",
  },
  newOrder: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue",
    color: colors.white,
  },
  orderInfoSection: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "space-between",
    marginBottom: 20,
  },
});
